<template lang="jade">
  button(
    type="button"
    @click="expand"
  )
    i.fa(v-bind:class="{'fa-plus': !expanded, 'fa-minus': expanded }")
</template>

<script>
export default {
  data: () => ({}),
  props: {
    dataset: {
      type: String || Number,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    expanded: {
      type: Boolean
    }
  },
  methods: {
    expand () {

    }
  }
}
</script>



// WEBPACK FOOTER //
// expander.vue?fa481dc2